import { render } from "./NumpadComponent.vue?vue&type=template&id=508000f6&scoped=true"
import script from "./NumpadComponent.vue?vue&type=script&lang=js"
export * from "./NumpadComponent.vue?vue&type=script&lang=js"

import "./NumpadComponent.vue?vue&type=style&index=0&id=508000f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508000f6"]])

export default __exports__